var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEditable)?_c('button',{directives:[{name:"edit",rawName:"v-edit.floating",value:(_vm.editName),expression:"editName",modifiers:{"floating":true}}],staticClass:"button button--32 button--editbutton",class:{
    'button--text-icon': !_vm.iconOnly,
    'button--icon': _vm.iconOnly
  },attrs:{"data-epi-property-render":"none","type":"button"}},[_c('svgicon',{attrs:{"name":"Controls/Edit"}}),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }